import AbstractWebRtcListenerAction from "./AbstractWebRtcListenerAction";
import AbstractWebRtcCall from "~/ts/library/webRtc/AbstractWebRtcCall";

export default class WebRtcCallPing extends AbstractWebRtcListenerAction {
    getAction(): string {
        return "webRtcCallPing";
    }

    onAction(payload: CometOperatorApplication.WebRtcCallPingCometMessageOpenApiModel): void {
        let currentCall = AbstractWebRtcCall.getCurrentCall();
        if (currentCall?.getId() == payload.callId) {
            currentCall.sendPong();
        }
    }

}